import ApplicationController from '../application_controller';

// Connects to data-controller="administrators--department-checkbox"
export default class extends ApplicationController {
  static targets = ['checkbox'];

  connect() {
    super.connect();
  }

  toggleWithChildren(event) {
    const { currentTarget, params: { uuids } } = event;

    this.checkboxTargets.forEach((checkbox) => {
      if (uuids.includes(checkbox.value)) {
        checkbox.checked = currentTarget.checked;
      }
    });
  }
}
